const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPlumbing3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.067,
    height: 53.333,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 52.704,
    height: 52.189,
    x: 2.896,
    y: 1.043,
    ry: 11.485,
    style: {
      fill: "#e14f45",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.06087
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.94 5.045c2.956.187 1.028 6.853 2.06 8.01l2.987 3.344c1.284 1.438-3.323 1.42-4.636 1.42-1.313 0-5.676-.868-4.327-2.244l2.472-2.52c1.35-1.376-.9-8.159 1.443-8.01Z",
    style: {
      fill: "#e14f45",
      stroke: "#fff",
      strokeWidth: 1.20248
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.248 2.322a3.547 3.873 0 0 0-3.342 2.574c-1.765-.631-4.526-.982-5.771-.982-1.906 0-3.451 1.13-3.451 2.524 0 1.393 1.545 2.521 3.45 2.521 1.248 0 4.018-.617 5.782-1.434a3.547 3.873 0 0 0 3.332 2.543 3.547 3.873 0 0 0 3.361-2.632c1.766.81 4.513 1.421 5.754 1.421 1.906 0 3.45-1.13 3.45-2.523 0-1.394-1.544-2.523-3.45-2.523-1.252 0-4.041.355-5.804.994a3.547 3.873 0 0 0-3.311-2.483Z",
    style: {
      fill: "#e14f45",
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.664,
    height: 4.615,
    x: 20.916,
    y: 15.973,
    ry: 2.307,
    style: {
      fill: "#e14f45",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 1.01957
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 24.395,
    y: 42.869,
    style: {
      fontSize: "29.0689px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      strokeWidth: 0.726722
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.395,
    y: 42.869,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      fill: "#fff",
      strokeWidth: 0.726722
    }
  }, "#")), /*#__PURE__*/React.createElement("path", {
    d: "M21.318 22.657s-1.578 2.432-2.78 1.957c-2.587-1.023-5.836-.9-8.342.309-1.996.963-3.456 3.009-4.326 5.046-1.097 2.57-1.25 5.352-.824 8.342.174 1.22.53 3.841 1.648 3.81 2.503-.068 5.89 1.044 7.827-.72.826-.753.373-2.206.618-3.296.148-.658.01-1.51.515-1.957 1.712-1.515 6.797-.927 6.797-.927",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 24.423,
    y: 54.881,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "65.3842px",
      lineHeight: 1.25,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#e14f45",
      strokeWidth: 3.14457,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    transform: "scale(1.13896 .878)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.423,
    y: 54.881,
    style: {
      stroke: "#e14f45",
      strokeWidth: 3.14457,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }, "1")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 58.645,
    y: 26.332,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "35.4002px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      InkscapeFontSpecification: "&quot",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#e14f44",
      fillOpacity: 0.964706,
      strokeWidth: 0.885004
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58.645,
    y: 26.332,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "23.6001px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial",
      strokeWidth: 0.885004
    }
  }, "First Time")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 61.536,
    y: 46.326,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "31.5131px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      InkscapeFontSpecification: "&quot",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#e14f44",
      fillOpacity: 0.964706,
      strokeWidth: 0.787828
    },
    transform: "scale(.99164 1.00843)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 61.536,
    y: 46.326,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "21.0088px",
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial",
      strokeWidth: 0.787828
    }
  }, "Plumbing Co.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlumbing3);
export default __webpack_public_path__ + "static/media/logo-plumbing3.e5001edb15a19df36b9af4b7333c0c3c.svg";
export { ForwardRef as ReactComponent };